import { create } from 'zustand';

import { createInboxEntryCommentsSlice } from './actions';
import { InboxEntryCommentsStore } from './types';

export const useInboxEntryCommentsStore = create<InboxEntryCommentsStore>()(
  (set, get, store) => ({
    ...createInboxEntryCommentsSlice(set, get, store),
  }),
);
